import React from 'react';
import './App.css';

import CustomizedTables from './Lists';

import { makeStyles } from '@material-ui/core/styles';



function App() {
  // const { listen } = useHistory();

  const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }));


  // });

  const classes = useStyles();
  return (

    <div className="App">

      <body className={classes.root}>
        <CustomizedTables totalCount={0}/>

      </body>
    </div>
  );
}



export default App;
